import { React } from 'react';
import _noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
import ConfirmDeactivate from '../../../../common/components/ConfirmDeactivate/ConfirmDeactivate';

const DeleteTeamModal = ({ teamData, isVisible, closeModal }) => {
  const handleAccept = () => {
    // handle when developing
    console.log('Accepted');
  };
  const message = `Are you sure you want to delete '${
    teamData.data.group_name
  }'?`;

  return (
    <ConfirmDeactivate
      message={message}
      isVisible={isVisible}
      closeModal={closeModal}
      buttonLabel='Delete'
      onContinueClick={handleAccept}
      warning
    />
  );
};

DeleteTeamModal.propTypes = {
  teamData: PropTypes.objectOf(PropTypes.any),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
};

DeleteTeamModal.defaultProps = {
  teamData: {},
  isVisible: false,
  closeModal: _noop,
};

export default DeleteTeamModal;
